<template>
  <div>
    <server-error :error="error" />
    <div v-if="isLoaded">
      <div v-if="reportTableData !== null">
        <button class="b-btn mx-6" @click="exportReportData">
          <dynamic-icon class="b-btn__icon" icon="xls"></dynamic-icon>
          {{$t('CONTENT.reportPage.download_excel')}}
        </button>
        <div class="b-reports__table-wrapper">
          <div class="b-full-table b-reports__table-wrap mt-4">
            <!--          Шапка-->
            <div class="b-reports__table-header-wrap">
              <!--            <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">-->
              <!--              Филиал-->
              <!--            </div>-->
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.contract_code')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.lessor')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.lessor_type')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.contract_number')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.contract.contract_date')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.asset_name')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.asset_type')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.inventory_number')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.spi')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.reportPage.spi_on_end_date')}}
              </div>
              <div class="b-reports__table-header-block-wrap">
                <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-block-title">
                  {{$t('CONTENT.reportPage.initial_cost')}}
                </div>
                <div class="b-reports__table-header-block-inner">
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.initial_cost_start_cost')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.initial_cost_initial_recognition_cost')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.adjustment_increase')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.adjustment_decrease')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.disposal')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.initial_cost_end_cost')}}
                  </div>
                </div>
              </div>
              <div class="b-reports__table-header-block-wrap">
                <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-block-title">
                  {{$t('CONTENT.reportPage.cumulative_amortization')}}
                </div>
                <div class="b-reports__table-header-block-inner">
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.amortization_sum_before_period')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.amortization_sum_in_period')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.adjustment_decrease')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.disposal')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.amortization_sum_on_period_end')}}
                  </div>
                </div>
              </div>
              <div class="b-reports__table-header-block-wrap">
                <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-block-title">
                  {{$t('CONTENT.reportPage.report_devaluation')}}
                </div>
                <div class="b-reports__table-header-block-inner">
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.cost_before_devaluation')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.devaluation_sum_before_period')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.devaluation_in_period')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.devaluation_recovery_in_period')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.adjustment_decrease')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.disposal')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.devaluation_sum_on_period_end')}}
                  </div>
                  <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                    {{$t('CONTENT.reportPage.cost_after_devaluation')}}
                  </div>
                </div>
              </div>
            </div>
            <div class="b-reports__table-content-wrap">
              <!--          Филиалы-->
              <div class="b-reports__table-row" v-for="item in reportTableData.rows">
                <!--            <div-->
                <!--              class="b-full-table__cell b-reports__table-cell"-->
                <!--            >{{item.subsidiary}}-->
                <!--            </div>-->
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.contractCode}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{getLessorName(item.lessorId)}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{$t(`CONTENT.reportPage.${item.counterpartyType}`)}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.contractNumber}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.contractDate | dateFormatted}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.assetName}} {{item.assetComponentName !== null ? ` - ${item.assetComponentName}` : ''}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{getAssetType(item.underlyingAssetTypeId)}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.inventoryNumber}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.spiMonthCount}}
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >{{item.remainingSpiMonthCount}}
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.initialCost.startCost)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.initialCost.initialRecognitionCost)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.initialCost.adjustmentsIncrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.initialCost.adjustmentsDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.initialCost.disposal)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.initialCost.endCost)}}
                  </div>
                </div>

                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.amortization.amortizationSumBeforePeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.amortization.amortizationSumInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.amortization.adjustmentDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.amortization.disposal)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.amortization.amortizationSumOnPeriodEnd)}}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.devaluation.costBeforeDevaluation)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.devaluation.devaluationSumBeforePeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.devaluation.devaluationInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.devaluation.devaluationRecoveryInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.devaluation.adjustmentsDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.devaluation.disposal)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.devaluation.devaluationSumOnPeriodEnd)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(item.devaluation.costAfterDevaluation)}}
                  </div>
                </div>
              </div>
              <!--          Итого-->
              <div class="b-reports__table-row b-reports__table-row-total">
                <!--            <div-->
                <!--              class="b-full-table__cell b-reports__table-cell"-->
                <!--            >-->
                <!--            </div>-->
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                  {{$t('CONTENT.reportPage.related_parties_total')}}
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.startCost)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.initialRecognitionCost)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.adjustmentsIncrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.adjustmentsDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.disposal)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.initialCost.endCost)}}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.amortization.amortizationSumBeforePeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.amortization.amortizationSumInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.amortization.adjustmentDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.amortization.disposal)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.amortization.amortizationSumOnPeriodEnd)}}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.costBeforeDevaluation)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.devaluationSumBeforePeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.devaluationInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.devaluationRecoveryInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.adjustmentsDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.disposal)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.devaluationSumOnPeriodEnd)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.relatedPartiesTotal.devaluation.costAfterDevaluation)}}
                  </div>
                </div>
              </div>
              <div class="b-reports__table-row b-reports__table-row-total">
                <!--            <div-->
                <!--              class="b-full-table__cell b-reports__table-cell"-->
                <!--            >-->
                <!--            </div>-->
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                  {{$t('CONTENT.reportPage.total_for_third_party_companies')}}
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.startCost)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.initialRecognitionCost)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.adjustmentsIncrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.adjustmentsDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.disposal)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.initialCost.endCost)}}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.amortization.amortizationSumBeforePeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.amortization.amortizationSumInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.amortization.adjustmentDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.amortization.disposal)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.amortization.amortizationSumOnPeriodEnd)}}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.costBeforeDevaluation)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.devaluationSumBeforePeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.devaluationInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.devaluationRecoveryInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.adjustmentsDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.disposal)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.devaluationSumOnPeriodEnd)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForThirdPartyCompanies.devaluation.costAfterDevaluation)}}
                  </div>
                </div>
              </div>
              <div class="b-reports__table-row b-reports__table-row-total">
                <!--            <div-->
                <!--              class="b-full-table__cell b-reports__table-cell"-->
                <!--            >-->
                <!--            </div>-->
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                  {{$t('CONTENT.reportPage.total_for_vgo')}}
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.startCost)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.initialRecognitionCost)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.adjustmentsIncrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.adjustmentsDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.disposal)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.initialCost.endCost)}}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForVgo.amortization.amortizationSumBeforePeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.amortization.amortizationSumInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.amortization.adjustmentDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.amortization.disposal)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForVgo.amortization.amortizationSumOnPeriodEnd)}}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.costBeforeDevaluation)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.devaluationSumBeforePeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.devaluationInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.devaluationRecoveryInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.adjustmentsDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.disposal)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.devaluationSumOnPeriodEnd)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.totalForVgo.devaluation.costAfterDevaluation)}}
                  </div>
                </div>
              </div>
              <div class="b-reports__table-row b-reports__table-row-total">
                <!--          <div-->
                <!--            class="b-full-table__cell b-reports__table-cell"-->
                <!--          >-->
                <!--          </div>-->
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                </div>
                <div
                  class="b-full-table__cell b-reports__table-cell"
                >
                  {{$t('CONTENT.reportPage.total')}}
                </div>

                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.initialCost.startCost)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.initialCost.initialRecognitionCost)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.initialCost.adjustmentsIncrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.initialCost.adjustmentsDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.initialCost.disposal)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.initialCost.endCost)}}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.amortization.amortizationSumBeforePeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.amortization.amortizationSumInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.amortization.adjustmentDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.amortization.disposal)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.amortization.amortizationSumOnPeriodEnd)}}
                  </div>
                </div>
                <div class="b-reports__table-block-wrap">
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.devaluation.costBeforeDevaluation)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.devaluation.devaluationSumBeforePeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.devaluation.devaluationInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.devaluation.devaluationRecoveryInPeriod)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.total.devaluation.adjustmentsDecrease)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >
                    {{convertDecimalToStringForChart(reportTableData.total.devaluation.disposal)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.devaluation.devaluationSumOnPeriodEnd)}}
                  </div>
                  <div
                    class="b-full-table__cell b-reports__table-cell"
                  >{{convertDecimalToStringForChart(reportTableData.total.devaluation.costAfterDevaluation)}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportsAPI from "../api/ReportsAPI";
import convertDecimalForChart from "@/utils/converters/convert.decimal.for.chart";
import { mapGetters } from "vuex";

export default {
  props: {
    dataForReport: {
      type: Object,
    },
  },
  data() {
    return {
      error: null,
      reportTableData: null,
      isHideLeasePaymentsGroupColumns: false,
      isHideInitialRecognitionColumns: false,
    };
  },
  async created() {
    await this.formReport(this.dataForReport);
  },
  watch: {
    dataForReport: {
      handler(newVal) {
        this.formReport(newVal);
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters(['allCounterparties']),
    ...mapGetters(['getUnderlyingAssetTypes']),
  },
  methods: {
    async formReport(data) {
      try {
        this.$loadingManager.addLoadingStep();
        this.error = null;
        this.reportTableData = null;
        this.reportTableData = await new ReportsAPI().getDecryptionReportBasedOnAssets({
          periodStart: data.periodStart,
          periodEnd: data.periodEnd,
          contractId: data.contractId,
          lesseeId: data.lesseeId
        });
        this.$parent.nonActiveContractIds = this.reportTableData.nonActiveContractIds;
        this.$loadingManager.loadingStepLoaded();
      } catch (e) {
        this.$loadingManager.hideLoadScreen();
        this.error = e;
      }
    },

    convertDecimalToStringForChart(decimal) {
      return convertDecimalForChart(decimal);
    },

    async exportReportData() {
      this.error = null;
      try {
        const api = new ReportsAPI();
        const response = await api.exportResultOfDecryptionReportBasedOnAssets(this.reportTableData);

        let filename = null;
        let filenameInURI = null;

        let headerContentDisposition = response.headers['content-disposition'].split(';');
        for (let i = 0; i < headerContentDisposition.length; i++) {
          let item = headerContentDisposition[i].split('=');
          if(item[0].trim() === 'filename*') {
            filenameInURI = item[1].split("''");
            filename = decodeURIComponent(filenameInURI[1]);
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        this.error = e;
        console.error(e);
      }
    },
    getLessorName(lessorId) {
      for (let i = 0; i < this.allCounterparties.length; i++) {
        if(this.allCounterparties[i].idInDB === lessorId) {
          return this.allCounterparties[i].displayName;
        }
      }
    },
    getAssetType(assetTypeId) {
      for (let i = 0; i < this.getUnderlyingAssetTypes.length; i++) {
        if(this.getUnderlyingAssetTypes[i].idInDb === assetTypeId) {
          return this.getUnderlyingAssetTypes[i].name;
        }
      }
    },
  }
};
</script>
